import { Franchises } from '~/lib/data-contract';
import { EnvironmentName } from '~/shared/utils/public-variables/runtime-config';

enum EasysizeSiteIds {
    // Production sites
    toejeksperten = '05b4791ed2',
    wagner = 'bbe0d1dbe8',
    wagner_SE = '1f1bca5e34',
    lindbergh = 'a070ec3a28',
    junkdeluxe = '0fbba7a29b',
    bison = '383cccb969',

    // Local/test sites related to Umbraco platform
    test = 'd39005ae87',
}

export const EasysizeIdTable: {
    [key in Franchises]?: {
        [key in EnvironmentName]: string;
    };
} = {
    8: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.wagner,
    },
    10: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.toejeksperten,
    },
    100: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.wagner_SE,
    },
    1337: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.lindbergh,
    },
    1340: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.junkdeluxe,
    },
    1342: {
        local: EasysizeSiteIds.test,
        development: EasysizeSiteIds.test,
        staging: EasysizeSiteIds.test,
        production: EasysizeSiteIds.bison,
    },
};

export const EasysizeElementIds = {
    placeholder: 'easysize-placeholder',
    recommendation_placeholder: 'easysize-placeholder',
    add_to_cart_btn_selector: 'easysize-add-to-cart-button',
};
